import React from "react";
function VideoProgress({ saveButtonRef, onEndInterviewClick, remainingCount }) {
  return (
    <div className="text-right">
      <ul className="d-flex align-items-center flex-wrap w-100 mb-3 justify-content-end">
        <li>
          <button
            className="btn btn-primary border-radius-10 mb-2 mb-md-0 mr-0 mr-sm-3"
            ref={saveButtonRef}
          >
            Save
          </button>
        </li>
        <li>
          <button
            className="btn btn-danger mb-2 mb-md-0 border-radius-10"
            onClick={() => onEndInterviewClick()}
          >
            Submit Assessment
          </button>
        </li>
      </ul>
      <div className="d-flex">
        <p className="font-weight-medium text-grey-4 border rounded-lg pl-2 py-1 mb-0 mr-3">
          Remaining Question:{" "}
          <span className="font-weight-medium bg-grey py-1 px-2 m-1 rounded">
            {remainingCount}
          </span>
        </p>
        <p className="font-weight-medium text-grey-4 border rounded-lg pl-2 py-1 mb-0">
          Remaining Time:{" "}
          <span className="font-weight-medium bg-grey py-1 px-2 m-1 rounded">
            ~{remainingCount * 3} mins
          </span>
        </p>
      </div>
    </div>
  );
}

export default VideoProgress;
